export const translations = {
  en: {
    translation: {
      common: {
        en: 'English',
        ru: 'Russian',
        de: 'German',
        it: 'Italian',
        pl: 'Polish',
        hy: 'Armenian',
        auto: 'Auto',
        you: 'You',
        assistant: 'Assistant',
        error: 'Error',
        saving: 'Saving',
        ok: 'OK',
        yes: 'Yes',
        no: 'No',
        next: 'Next',
        back: 'Back',
        select: 'Select',
        home: 'Home',
        level: 'Level',
        unit: 'Unit',
        lesson: 'Lesson',
        slide: 'Slide',
        all: 'All',
        allLevels: 'All levels',
        showAnswer: 'Show answer',
        loading: 'Loading...',
        settings: 'Settings',
        profile: 'Profile',
        signOut: 'Sign Out',
        signIn: 'Sign In',
        signInGoogle: 'Sign In with Google',
        authorization: 'Authorization',
        actions: 'Actions',
        create: 'Create',
        edit: 'Edit',
        retry: 'Retry',
        controlPanel: 'Control Panel',
        goHome: 'Home Page',
        enterText: 'Enter text',
      },
      dates: {
        today: 'Today',
        yesterday: 'Yesterday',
        previous7Days: 'Previous 7 days',
        previous30Days: 'Previous 30 days',
        olderThan30Days: 'Older than 30 days',
      },
      prompts: {
        listen: `Let's start the training. Try to translate the first of {{sentencesCount}} sentences to $t(common.{{language}}):`,
        translate: `Let's start the training. Try to translate the first of {{sentencesCount}} sentences to $t(common.{{language}}):`,
      },
      messages: {
        listen: `Let's start the training.`,
        translate: `Let's start the training.`,
      },
      profile: {
        speakers: {
          en: 'English speakers',
          ru: 'Russian speakers',
          de: 'German speakers',
          it: 'Italian speakers',
          pl: 'Polish speakers',
          hy: 'Armenian speakers',
        },
        nativeLanguage: 'Native language',
        targetLanguage: 'Target language',
        interfaceLanguage: 'Interface language',
        pair: '$t(common.{{tl}}) for $t(profile.speakers.{{nl}})',
        title: 'User Profile',
        createNew: 'New Profile',
        formDescription: 'Choose the languages for this profile.',
        emailDigest: 'Enable email digests',
        emailDigestDescription: 'Receive a learning summary when you have recent activity or upcoming reviews.',
        emptyTitle: 'No profiles yet',
        emptyDescription: 'Create a profile to start learning.',
        loadError: 'Failed to load profiles.',
        saveError: 'Failed to save the profile.',
        deleteError: 'Failed to delete the profile.',
        edit: 'Edit Profile',
        create: 'Create Profile',
        actions: {
          edit: 'Edit',
          delete: 'Delete',
          update: 'Update',
          create: 'Create',
          cancel: 'Cancel',
        },
        deleteConfirm: 'Are you sure you want to delete this profile?',
      },
      transliteration: {
        title: 'Transliteration',
        description: 'Show the Armenian text as IPA, Cyrillic and Latin.',
        enable: 'Enable transliteration',
        representations: 'Representations',
        ipa: 'IPA',
        cyrillic: 'Cyrillic',
        latin: 'Latin',
      },
      home: {
        title: 'Language learning',
        description: 'Choose a study mode in the sidebar to start learning.',
        dashboard: {
          title: 'Your progress',
          subtitle: 'Studying since {{date}}',
          finishBy: 'Course finish forecast: ~{{date}}',
          studied: 'Learned',
          ofTotal: 'of {{total}} cards',
          paceLabel: 'Pace',
          perDay: '/day',
          accelerating: 'Speeding up',
          decelerating: 'Slowing down',
          steady: 'Steady',
          streakLabel: 'Streak',
          streakRecord: 'record {{n}} days',
          memoryTile: 'Memory strength',
          memoryTileHint: 'average recall of learned cards',
          chartTitle: 'Progress and forecast',
          chartDesc: 'Past results and future projection at your current pace',
          today: 'today',
          forecast: 'forecast',
          calendarTitle: 'Study calendar',
          heatmapHint: 'Reviews per day',
          less: 'Less',
          more: 'More',
          reviewsCount: '{{n}} reviews',
          memoryTitle: 'Memory health',
          strength: 'strength',
          noStudyScenario: 'If you skip reviews for 30 days',
          halfLifeIn: '−50% in {{n}} days',
          decayDrop: '−{{n}}% over a month',
          cardMix: 'Learned cards mix',
          lapsed: '{{n}} lapses',
          bucket: {
            strong: 'Strong',
            steady: 'Medium',
            fragile: 'Fragile',
          },
          nextReviews: 'Upcoming reviews',
          review: {
            overdue: 'Overdue',
            today: 'Today',
            tomorrow: 'Tomorrow',
            threeDays: '≤3 days',
            week: 'Week',
            twoWeeks: '2 weeks',
            month: 'Month',
            later: 'Later',
          },
          deckTitle: 'Current deck',
          decksTitle: 'Started modules',
          decksDesc: 'Modules with at least 1% progress, separated by study mode',
          decksSummary: '{{modules}} modules · {{cards}} learned cards · {{due}} due · memory {{memory}}%',
          unknownModule: 'Started module',
          deckModule: 'Level {{level}} · Module {{unit}}',
          moduleSummary: '{{cards}} learned · {{due}} due · memory {{memory}}%',
          deckMemory: 'Memory {{n}}%',
          noStartedDecks: 'No started modules yet',
          deckMode: {
            listen: 'Listening',
            translate: 'Translation',
          },
          deckLevel: 'Level {{level}}',
          deckDue: 'Due: {{n}}',
          deckNew: 'New: {{n}}',
          deckEta: 'Finish by {{date}}',
          continue: 'Continue',
        },
      },
      settings: {
        general: 'General',
        cards: 'Cards',
        theme: 'Color scheme',
        timezone: 'Time zone',
        timezoneDescription: 'Digest emails arrive at 8:00 in this time zone.',
        timezoneSearch: 'Search time zones...',
        timezoneNotFound: 'Time zone not found.',
        emailDigestPaused: 'Pause email digests',
        emailDigestPausedDescription: 'Do not receive digest emails until you turn this off.',
        themeModes: {
          system: 'System',
          dark: 'Dark',
          light: 'Light',
        },
      },
      emailDigest: {
        subject: 'Your {{language}} learning digest for {{date}}',
        intro: 'Good morning, here is your learning digest.',
        moduleTitle: 'Your current module',
        stoppedAt: 'You stopped at this card:',
        notStarted: 'This side of the module has not been started yet.',
        continue: 'Continue',
        memoryTitle: 'Memory health',
        memoryHint: 'How well your learned cards are remembered now.',
        statsTitle: 'Your progress',
        learned: 'Learned cards',
        pace: 'Pace',
        perDay: '/ day',
        streak: 'Current streak',
        memoryStrength: 'Memory strength',
        chartTitle: 'Progress and forecast',
        chartAlt: 'Progress and forecast chart',
        noProgress: 'Start a study session to see your progress here.',
        settings: 'Manage digest settings',
        footer: 'You receive this message because email digests are enabled for your profile.',
        nextMilestone: 'Next milestone',
        courseCompletion: 'Course completion',
        forecastUnavailable: 'No forecast yet',
        forecastReached: '{{prefix}}{{date}} · reached',
        forecastInDays: '{{prefix}}{{date}} · in {{days}} days',
        record: 'Record: {{n}}',
        moduleFallback: 'Level {{level}} · Module {{unit}}',
        trend: {accelerating: 'Speeding up', decelerating: 'Slowing down', steady: 'Steady'},
        mode: {listen: 'Listening', translate: 'Translation'},
        bucket: {strong: 'Strong', steady: 'Medium', fragile: 'Fragile'},
        review: {
          overdue: 'Overdue',
          today: 'Today',
          tomorrow: 'Tomorrow',
          threeDays: '≤3 days',
          week: 'Week',
          twoWeeks: '2 weeks',
          month: 'Month',
          later: 'Later',
        },
        subjectLanguageNames: {
          en: {en: 'English', ru: 'английского'},
          ru: {en: 'Russian', ru: 'русского'},
          de: {en: 'German', ru: 'немецкого'},
          it: {en: 'Italian', ru: 'итальянского'},
          pl: {en: 'Polish', ru: 'польского'},
          hy: {en: 'Armenian', ru: 'армянского'},
        },
      },
      cards: {
        tabs: {
          front: 'Front',
          frontShort: 'F',
          back: 'Back',
          backShort: 'B',
          studyingCards: 'Study cards',
        },
        modules: {
          level1: {
            module1: '1. People & Actions',
            module2: '2. Family, Prepositions of Place, Questions',
            module3: '3. Time, Days of the Week, Habits',
            module4: '4. Shopping, Prices, Comparisons',
          },
          level2: {
            module1: '1. Travel, Weather, Future',
            module2: '2. School and Work, the Past',
            module3: '3. Socializing, Requests, This and That',
            module4: '4. Leisure, Emotions, Future Plans',
          },
          level3: {
            module1: '1. Health, Housework, Advice',
            module2: '2. Animals, Continents, Relative Clauses',
            module3: '3. Cooking, Tools, Conditionals',
            module4: '4. Countries, News, Passive',
          },
          level4: {
            module1: '1. Travel, Museums, Instead',
            module2: '2. Jobs, Hobbies, Made By',
            module3: '3. Moving In, Repairs, Just Now',
            module4: '4. Clothes, Health, While Clauses',
          },
          level5: {
            module1: '1. Industry, Farming, Regrets',
            module2: '2. School, Science, Subjunctive',
            module3: '3. Accidents, Disasters, Rescue',
            module4: '4. Family, Neighborhood, However',
          },
        },
        moduleProgressTooltip:
          'Overall progress: {{average}}%\nFront side: {{front}}% ({{frontN}}/{{frontM}})\nBack side: {{back}}% ({{backN}}/{{backM}})',
        newCards: 'New Cards',
        studyingCards: {
          eyebrow: 'Next · Card feed',
          title: 'Get acquainted with the cards',
          subtitle: 'See the image, meaning, and target language together before studying.',
          count: 'Cards:',
          image: 'Card image',
          nativeLanguage: 'Native language',
          targetLanguage: 'Language you learn',
          feedLabel: 'Next card feed',
          empty: 'No cards to preview.',
        },
      },
      study: {
        title: 'Studying material',
        tabSlide: 'Slide',
        tabLesson: 'Lesson',
        rememberedProgress: 'Remembered: {{n}} of {{m}}',
        settingsDescription: 'Configure this study session.',
        autoSpeak: 'Auto voice',
        shuffle: 'Random order for reviews',
        flip3d: '3D flip',
        close: 'Close',
        remember: 'Remembered',
        previous: 'Previous',
        next: 'Next',
        completeTitle: 'Congratulations!',
        completeMessage: 'You remembered all cards of this lesson.',
        emptyTitle: 'No cards',
        emptyMessage: 'There are no cards with translation in this lesson.',
        errorTitle: 'Failed to load cards',
        loading: 'Loading cards...',
        speak: 'Speak',
        speakFemaleTooltip: 'Female voice.\nClick for normal speed.\nHold for slow repeats.',
        speakMaleTooltip: 'Male voice.\nClick for normal speed.\nHold for slow repeats.',
        speakError: 'Failed to generate speech',
        flipCard: 'Flip card',
        again: "Didn't recall",
        hard: 'Hard',
        good: 'Good',
        easy: 'Easy',
        cardsEmpty: 'No cards for this scope',
        cardsEmptyHint: 'Try choosing another level or lesson.',
        cardsWaiting: 'All available cards are scheduled for later',
        cardsWaitingHint: 'Next cards will be available in about {{time}}.',
        cardsReady: 'Cards are ready. You can continue studying.',
        cardsContinue: 'Continue studying',
        cardsComplete: 'You have learned all cards',
        cardsProgress: '{{n}} of {{m}}',
        showAnswer: 'Show answer',
        hideAnswer: 'Hide answer',
        enableSwipe: 'Swipe navigation',
        hideNavButtons: 'Hide Prev/Next buttons',
        floatingControls: 'Move card controls to the corner',
        floatingControlsSize: 'Corner controls size',
        floatingControlsSizes: {
          10: 'Smallest',
          12: 'Small',
          14: 'Below medium',
          15: 'Medium',
          16: 'Above medium',
          18: 'Large',
          20: 'Largest',
        },
        showImageOnFront: 'Show image on the front in reading/listening mode',
      },
      cp: {
        translations: 'Translations',
        settings: 'General settings',
        modelSettingsTitle: 'Model settings',
        roleColumn: 'Role',
        modelColumn: 'Model',
        priceColumn: 'Price / 1M tokens',
        reasoningColumn: 'Reasoning',
        roles: {
          translation_main: 'Main translation',
          translation_weak: 'Fast translation',
          image_description: 'Image description',
        },
        settingsDescription: 'Configure models for all text and media roles.',
        modelSettingsDescription: 'Choose a compatible model and reasoning level for each role.',
        modelCatalog: 'OpenRouter model catalog',
        models: 'models',
        refreshCatalog: 'Refresh catalog',
        emptyCatalog: 'The model catalog is empty. Refresh it to load compatible models.',
        saveSettings: 'Save changes',
        emailDigestTitle: 'Email digests',
        emailDigestDescription: 'Generate a preview for the currently selected profile.',
        emailDigestPreview: 'Preview email',
        emailDigestPreviewTitle: 'Email digest preview',
        emailDigestPreviewDescription:
          'This preview uses the currently selected profile of the signed-in administrator.',
        emailDigestPreviewNoProfile: 'Select or create a profile for this administrator first.',
        emailDigestProfileLoadError: 'Failed to load a profile for this administrator.',
        emailDigestPreviewError: 'Failed to generate the email preview.',
        emailDigestSendPreview: 'Send preview to my email',
        emailDigestSendSuccess: 'Preview sent to your email.',
        emailDigestSendError: 'Failed to send the preview email.',
        users: 'Users',
        ttsSettings: 'TTS settings',
        noUsers: 'No users found',
        role: 'Role',
        authMethods: 'Sign-in methods',
        createUser: 'Create user',
        editUser: 'Edit user',
        next: 'Next',
        nextSections: {concepts: 'Concepts', entities: 'Entities', cards: 'Cards'},
        nextCatalogTitle: 'Next content catalog',
        nextCatalogSubtitle: 'Inspect the file-based learning model without changing its source.',
        nextReadOnly: 'Read only',
        nextSource: 'Source: docs/next/database',
        nextFilterTitle: 'Filter collection',
        nextSearchPlaceholder: 'Search by ID or description',
        nextKind: 'Type',
        nextCefr: 'CEFR level',
        nextConcept: 'Concept',
        nextAllKinds: 'All types',
        nextAllLevels: 'All levels',
        nextAllConcepts: 'All concepts',
        nextImageFilter: 'Card images',
        nextAllImages: 'All images',
        nextMissingImages: 'Missing image',
        nextApply: 'Apply filters',
        nextReset: 'Reset',
        nextRecords: 'records',
        nextPages: 'Pages',
        nextGoToPage: 'Go to page {{page}}',
        nextPrevious: 'Previous',
        nextNext: 'Next',
        nextPrevCard: 'Previous card',
        nextNextCard: 'Next card',
        nextEmpty: 'No records match the filters.',
        nextId: 'ID',
        nextType: 'Type',
        nextDescription: 'Description',
        nextImage: 'Image',
        nextSourceFile: 'Source file',
        nextScene: 'Scene',
        nextConcepts: 'Concepts',
        nextIntroduces: 'Introduces',
        nextReinforces: 'Reinforces',
        nextRequires: 'Requires',
        nextConceptCountsHint: 'Number of cards containing the concept up to and including this card.',
        nextConceptOccurrences: '{{concept}}: {{count}} cards, including this card',
        nextCardPreview: 'Card preview',
        nextCopyCardId: 'Copy card ID',
        nextCopyPrompt: 'Copy prompt',
        nextCopyPromptMj: 'Copy prompt with MJ parameters',
        nextImagesInheritedFrom: 'Images inherited from',
        nextAddLanguage: 'Add language',
        nextLanguages: 'Languages',
        nextNoLanguages: 'No languages',
        nextText: 'Text',
        nextImageDescription: 'Image description',
        nextTextDescription: 'Text note',
        nextEntityPreview: 'Entity preview',
        nextPrompt: 'Generation prompt',
        nextDependencies: 'Generation dependencies',
        nextFullscreenImage: 'Full-size image',
        nextNoDependencies: 'No image references.',
        nextDependentCards: 'Dependent cards',
        nextNoDependentCards: 'No cards depend on this entity.',
        nextDependentAsReference: 'reference',
        nextDependentAsMention: 'mention',
        nextLore: 'Lore',
        nextShowSchema: 'Show schema',
        nextSchemaTitle: 'Entity relationship schema',
        nextSchemaDescription: 'All entity relationships rendered with Mermaid.',
        nextSchemaDepth: 'Depth',
        nextSchemaTypes: 'Relationship types',
        nextSchemaGroups: 'Relationship groups',
        nextRelationGroup_family: 'Family',
        nextRelationGroup_ownership: 'Ownership',
        nextRelationGroup_social: 'Social',
        nextRelationGroup_other: 'Other',
        nextOutgoingRelationships: 'Outgoing',
        nextIncomingRelationships: 'Incoming',
        nextSchemaEmpty: 'No relationships match the filters.',
        nextSchemaLoading: 'Loading schema...',
        nextSchemaLoadFailed: 'Schema load failed',
        nextAdditionalImages: 'Additional images',
        nextSelectEntity: 'Select an entity to see its details.',
        nextNoText: 'No text in this language.',
        nextMediaUnavailable: 'Image unavailable',
        nextSelectCard: 'Select a card to see its preview.',
        nextItemsHint: 'Source records stay linked to the original YAML files.',
        nextDropImageHint: 'Drag an image here to replace it. It resizes to 1024x768.',
        nextUploadingImage: 'Uploading the image...',
        nextImageDescriptionPending: 'The image is updated. Its description arrives shortly.',
        nextImageUploadFailed: 'Image upload failed',
      },
      auth: {email: 'Email', password: 'Password', signInPassword: 'Sign in', or: 'or'},
      materials: {},
    },
  },
  ru: {
    translation: {
      common: {
        en: 'английский',
        ru: 'русский',
        de: 'немецкий',
        it: 'итальянский',
        pl: 'польский',
        hy: 'армянский',
        auto: 'Авто',
        you: 'Вы',
        assistant: 'Ассистент',
        error: 'Ошибка',
        saving: 'Сохранение',
        ok: 'ОК',
        yes: 'Да',
        no: 'Нет',
        next: 'Далее',
        nextLesson: 'cледующий',
        back: 'Назад',
        select: 'Выбрать',
        home: 'Главная',
        loading: 'Загрузка...',
        level: 'Уровень',
        unit: 'Модуль',
        lesson: 'Урок',
        slide: 'Слайд',
        all: 'Все',
        allLevels: 'Все уровни',
        showAnswer: 'Показать ответ',
        settings: 'Настройки',
        profile: 'Профиль',
        signOut: 'Выйти',
        signIn: 'Войти',
        signInGoogle: 'Войти с Google',
        authorization: 'Авторизация',
        actions: 'Действия',
        create: 'Создать',
        edit: 'Изменить',
        retry: 'Повторить',
        controlPanel: 'Панель управления',
        goHome: 'Главная страница',
        enterText: 'Введите текст',
      },
      dates: {
        today: 'Сегодня',
        yesterday: 'Вчера',
        previous7Days: 'Предыдущие 7 дней',
        previous30Days: 'Предыдущие 30 дней',
        olderThan30Days: 'Старше 30 дней',
      },
      prompts: {
        listen: 'Давайте начнем тренировку. Переведите первую из {{sentencesCount}} фраз на $t(common.{{language}}):',
        translate:
          'Давайте начнем тренировку. Переведите первую из {{sentencesCount}} фраз на $t(common.{{language}}):',
      },
      messages: {
        listen: 'Давайте начнем тренировку.',
        translate: 'Давайте начнем тренировку.',
      },
      profile: {
        speakers: {
          en: 'англоговорящих',
          ru: 'русскоговорящих',
          de: 'немецкоговорящих',
          it: 'итальяноговорящих',
          pl: 'польскоговорящих',
          hy: 'армяноязычных',
        },
        nativeLanguage: 'Родной язык',
        targetLanguage: 'Целевой язык',
        interfaceLanguage: 'Язык интерфейса',
        pair: '$t(common.{{tl}}) для $t(profile.speakers.{{nl}})',
        title: 'Профиль пользователя',
        createNew: 'Новый профиль',
        formDescription: 'Выберите языки для этого профиля.',
        emailDigest: 'Включить email-дайджесты',
        emailDigestDescription: 'Получайте сводку обучения после недавних занятий или перед проверками.',
        emptyTitle: 'Профилей пока нет',
        emptyDescription: 'Создайте профиль, чтобы начать обучение.',
        loadError: 'Не удалось загрузить профили.',
        saveError: 'Не удалось сохранить профиль.',
        deleteError: 'Не удалось удалить профиль.',
        edit: 'Редактировать профиль',
        create: 'Создать профиль',
        actions: {
          edit: 'Редактировать',
          delete: 'Удалить',
          update: 'Обновить',
          create: 'Создать',
          cancel: 'Отмена',
        },
        deleteConfirm: 'Вы уверены, что хотите удалить этот профиль?',
      },
      transliteration: {
        title: 'Транслитерация',
        description: 'Показывать армянский текст как IPA, кириллицу и латиницу.',
        enable: 'Включить транслитерацию',
        representations: 'Представления',
        ipa: 'IPA',
        cyrillic: 'Кириллица',
        latin: 'Латиница',
      },
      home: {
        title: 'Изучение языков',
        description: 'Выберите режим изучения в боковом меню, чтобы начать обучение.',
        dashboard: {
          title: 'Ваш прогресс',
          subtitle: 'Учите язык с {{date}}',
          finishBy: 'Прогноз завершения курса: ~{{date}}',
          studied: 'Изучено',
          ofTotal: 'из {{total}} карточек',
          paceLabel: 'Темп',
          perDay: 'в день',
          accelerating: 'ускорение',
          decelerating: 'замедление',
          steady: 'стабильно',
          streakLabel: 'Серия',
          streakRecord: 'рекорд {{n}} дн.',
          memoryTile: 'Прочность памяти',
          memoryTileHint: 'средняя вероятность вспомнить карточку',
          chartTitle: 'Прогресс и прогноз',
          chartDesc: 'Результаты прошлого и будущее при текущем темпе занятий',
          today: 'сегодня',
          forecast: 'прогноз',
          calendarTitle: 'Календарь занятий',
          heatmapHint: 'Повторения по дням',
          less: 'Меньше',
          more: 'Больше',
          reviewsCount: 'повторений: {{n}}',
          memoryTitle: 'Состояние памяти',
          strength: 'прочность',
          noStudyScenario: 'Если не повторять 30 дней',
          halfLifeIn: '−50% через {{n}} дн.',
          decayDrop: '−{{n}}% за месяц',
          cardMix: 'Изученные карточки',
          lapsed: '{{n}} с ошибками',
          bucket: {
            strong: 'Прочные',
            steady: 'Средние',
            fragile: 'Требуют повтора',
          },
          nextReviews: 'Ближайшие повторения',
          review: {
            overdue: 'Просрочено',
            today: 'Сегодня',
            tomorrow: 'Завтра',
            threeDays: '3 дня',
            week: 'Неделя',
            twoWeeks: '2 недели',
            month: 'Месяц',
            later: 'Позже',
          },
          deckTitle: 'Текущая колода',
          decksTitle: 'Начатые модули',
          decksDesc: 'Модули с прогрессом от 1%, отдельно для каждого режима',
          decksSummary:
            'Модулей: {{modules}} · изучено карточек: {{cards}} · к повторению: {{due}} · память: {{memory}}%',
          unknownModule: 'Начатый модуль',
          deckModule: 'Уровень {{level}} · Модуль {{unit}}',
          moduleSummary: 'Изучено: {{cards}} · к повторению: {{due}} · память: {{memory}}%',
          deckMemory: 'Память {{n}}%',
          noStartedDecks: 'Начатых модулей пока нет',
          deckMode: {
            listen: 'Аудирование',
            translate: 'Перевод',
          },
          deckLevel: 'Уровень {{level}}',
          deckDue: 'К повторению: {{n}}',
          deckNew: 'Новых: {{n}}',
          deckEta: 'Завершение ~{{date}}',
          continue: 'Продолжить',
        },
      },
      settings: {
        general: 'Общие',
        cards: 'Карточки',
        theme: 'Цветовая схема',
        timezone: 'Часовой пояс',
        timezoneDescription: 'Дайджест приходит в 8:00 по этому часовому поясу.',
        timezoneSearch: 'Поиск часового пояса...',
        timezoneNotFound: 'Часовой пояс не найден.',
        emailDigestPaused: 'Приостановить получение дайджестов',
        emailDigestPausedDescription: 'Не получать дайджесты, пока эта настройка включена.',
        themeModes: {
          system: 'Система',
          dark: 'Темная',
          light: 'Светлая',
        },
      },
      emailDigest: {
        subject: 'Ваш дайджест изучения {{language}} на {{date}}',
        intro: 'Доброе утро, это ваш дайджест обучения.',
        moduleTitle: 'Ваш текущий модуль',
        stoppedAt: 'Вы остановились на карточке:',
        notStarted: 'Эта сторона модуля ещё не начата.',
        continue: 'Продолжить',
        memoryTitle: 'Состояние памяти',
        memoryHint: 'Насколько хорошо вы сейчас помните изученные карточки.',
        statsTitle: 'Ваша статистика',
        learned: 'Изучено карточек',
        pace: 'Темп',
        perDay: '/ день',
        streak: 'Текущая серия',
        memoryStrength: 'Сила памяти',
        chartTitle: 'Прогресс и прогноз',
        chartAlt: 'График прогресса и прогноза',
        noProgress: 'Начните занятие, чтобы увидеть здесь прогресс.',
        settings: 'Настроить дайджесты',
        footer: 'Вы получаете это письмо, потому что дайджесты включены для вашего профиля.',
        nextMilestone: 'Следующая веха',
        courseCompletion: 'Завершение курса',
        forecastUnavailable: 'Прогноз пока недоступен',
        forecastReached: '{{prefix}}{{date}} · достигнуто',
        forecastInDays: '{{prefix}}{{date}} · через {{days}} дн.',
        record: 'Рекорд: {{n}}',
        moduleFallback: 'Уровень {{level}} · Модуль {{unit}}',
        trend: {accelerating: 'Ускорение', decelerating: 'Замедление', steady: 'Стабильный темп'},
        mode: {listen: 'Аудирование', translate: 'Перевод'},
        bucket: {strong: 'Сильная', steady: 'Средняя', fragile: 'Хрупкая'},
        review: {
          overdue: 'Просрочено',
          today: 'Сегодня',
          tomorrow: 'Завтра',
          threeDays: '≤3 дней',
          week: 'Неделя',
          twoWeeks: '2 недели',
          month: 'Месяц',
          later: 'Позже',
        },
        subjectLanguageNames: {
          en: {en: 'English', ru: 'английского'},
          ru: {en: 'Russian', ru: 'русского'},
          de: {en: 'German', ru: 'немецкого'},
          it: {en: 'Italian', ru: 'итальянского'},
          pl: {en: 'Polish', ru: 'польского'},
          hy: {en: 'Armenian', ru: 'армянского'},
        },
      },
      cards: {
        tabs: {
          front: 'Лицевая',
          frontShort: 'Лиц.',
          back: 'Обратная',
          backShort: 'Обр.',
          studyingCards: 'Карточки',
        },
        modules: {
          level1: {
            module1: '1. Люди и действия',
            module2: '2. Семья, предлоги места, вопросы',
            module3: '3. Время, дни недели, привычки',
            module4: '4. Покупки, цены, сравнения',
          },
          level2: {
            module1: '1. Путешествия, погода, будущее',
            module2: '2. Учёба и работа, прошлое',
            module3: '3. Общение, просьбы, этот/тот',
            module4: '4. Отдых, эмоции, планы на будущее',
          },
          level3: {
            module1: '1. Здоровье, быт, советы',
            module2: '2. Животные, глобус, придаточные',
            module3: '3. Готовка, инструменты, условия',
            module4: '4. Страны, новости, пассив',
          },
          level4: {
            module1: '1. Путешествия, музеи, вместо',
            module2: '2. Работа, хобби, кем создано',
            module3: '3. Переезд, ремонт, только что',
            module4: '4. Одежда, здоровье, одновременность',
          },
          level5: {
            module1: '1. Промышленность, ферма, сожаления',
            module2: '2. Учёба, наука, сослагательное',
            module3: '3. Аварии, стихии, помощь',
            module4: '4. Семья, соседи, однако',
          },
        },
        moduleProgressTooltip:
          'Общий прогресс: {{average}}%\nЛицевая сторона: {{front}}% ({{frontN}}/{{frontM}})\nОбратная сторона: {{back}}% ({{backN}}/{{backM}})',
        newCards: 'Новые карточки',
        studyingCards: {
          eyebrow: 'Next · Лента карточек',
          title: 'Знакомство с карточками',
          subtitle: 'Смотрите картинку, перевод и текст на изучаемом языке вместе.',
          count: 'Карточек:',
          image: 'Картинка карточки',
          nativeLanguage: 'Родной язык',
          targetLanguage: 'Изучаемый язык',
          feedLabel: 'Лента карточек Next',
          empty: 'Нет карточек для просмотра.',
        },
      },
      study: {
        title: 'Изучение материала',
        tabSlide: 'Слайд',
        tabLesson: 'Урок',
        rememberedProgress: 'Запомнено: {{n}} из {{m}}',
        settingsDescription: 'Настройте текущую сессию изучения.',
        autoSpeak: 'Автоозвучка',
        shuffle: 'Случайный порядок для повторов',
        flip3d: '3D-переворот',
        close: 'Закрыть',
        remember: 'Запомнил',
        previous: 'Предыдущая',
        next: 'Следующая',
        completeTitle: 'Поздравляем!',
        completeMessage: 'Вы запомнили все карточки этого урока.',
        emptyTitle: 'Нет карточек',
        emptyMessage: 'В этом уроке нет карточек с переводом.',
        errorTitle: 'Не удалось загрузить карточки',
        loading: 'Загрузка карточек...',
        speak: 'Озвучить',
        speakFemaleTooltip: 'Женский голос.\nКлик — обычная скорость.\nУдержание — медленные повторы.',
        speakMaleTooltip: 'Мужской голос.\nКлик — обычная скорость.\nУдержание — медленные повторы.',
        speakError: 'Ошибка озвучивания',
        flipCard: 'Перевернуть карточку',
        again: 'Не вспомнил',
        hard: 'Трудно',
        good: 'Хорошо',
        easy: 'Легко',
        cardsEmpty: 'Нет карточек для этого масштаба',
        cardsEmptyHint: 'Попробуйте выбрать другой уровень или урок.',
        cardsWaiting: 'Все доступные карточки запланированы на будущее',
        cardsWaitingHint: 'Следующие карточки будут доступны примерно через {{time}}.',
        cardsReady: 'Карточки готовы. Можно продолжить изучение.',
        cardsContinue: 'Продолжить изучение',
        cardsComplete: 'Вы выучили все карточки',
        cardsProgress: '{{n}} из {{m}}',
        showAnswer: 'Показать ответ',
        hideAnswer: 'Скрыть ответ',
        enableSwipe: 'Свайп-навигация',
        hideNavButtons: 'Скрыть кнопки Назад/Далее',
        floatingControls: 'Перенести кнопки карточек в угол',
        floatingControlsSize: 'Размер кнопок в углу',
        floatingControlsSizes: {
          10: 'Самый маленький',
          12: 'Маленький',
          14: 'Ниже среднего',
          15: 'Средний',
          16: 'Выше среднего',
          18: 'Большой',
          20: 'Самый большой',
        },
        showImageOnFront: 'Показывать картинку на лицевой стороне в режиме чтения/слушания',
      },
      cp: {
        translations: 'Переводы',
        settings: 'Общие настройки',
        modelSettingsTitle: 'Настройки моделей',
        roleColumn: 'Роль',
        modelColumn: 'Модель',
        priceColumn: 'Цена за 1M токенов',
        reasoningColumn: 'Reasoning',
        roles: {
          translation_main: 'Основной перевод',
          translation_weak: 'Быстрый перевод',
          image_description: 'Описание изображения',
        },
        settingsDescription: 'Настройте модели для всех текстовых и медийных ролей.',
        modelSettingsDescription: 'Выберите совместимую модель и уровень reasoning для каждой роли.',
        modelCatalog: 'Каталог моделей OpenRouter',
        models: 'моделей',
        refreshCatalog: 'Обновить каталог',
        emptyCatalog: 'Каталог пуст. Обновите его, чтобы загрузить совместимые модели.',
        saveSettings: 'Сохранить изменения',
        emailDigestTitle: 'Email-дайджесты',
        emailDigestDescription: 'Создайте предварительный просмотр для выбранного профиля.',
        emailDigestPreview: 'Предпросмотр письма',
        emailDigestPreviewTitle: 'Предпросмотр email-дайджеста',
        emailDigestPreviewDescription: 'Предпросмотр использует текущий профиль вошедшего администратора.',
        emailDigestPreviewNoProfile: 'Сначала выберите или создайте профиль для этого администратора.',
        emailDigestProfileLoadError: 'Не удалось загрузить профиль этого администратора.',
        emailDigestPreviewError: 'Не удалось создать предпросмотр письма.',
        emailDigestSendPreview: 'Отправить предпросмотр на мою почту',
        emailDigestSendSuccess: 'Предпросмотр отправлен на вашу почту.',
        emailDigestSendError: 'Не удалось отправить письмо с предпросмотром.',
        users: 'Пользователи',
        ttsSettings: 'Настройки озвучек',
        noUsers: 'Пользователи не найдены',
        role: 'Роль',
        authMethods: 'Способы входа',
        createUser: 'Создать пользователя',
        editUser: 'Изменить пользователя',
        next: 'Next',
        nextSections: {concepts: 'Концепции', entities: 'Сущности', cards: 'Карточки'},
        nextCatalogTitle: 'Каталог материалов Next',
        nextCatalogSubtitle: 'Просматривайте файловую модель обучения без изменения исходных данных.',
        nextReadOnly: 'Только чтение',
        nextSource: 'Источник: docs/next/database',
        nextFilterTitle: 'Фильтры каталога',
        nextSearchPlaceholder: 'Поиск по ID или описанию',
        nextKind: 'Тип',
        nextCefr: 'Уровень CEFR',
        nextConcept: 'Концепция',
        nextAllKinds: 'Все типы',
        nextAllLevels: 'Все уровни',
        nextAllConcepts: 'Все концепции',
        nextImageFilter: 'Картинки карточек',
        nextAllImages: 'Все картинки',
        nextMissingImages: 'Нет картинки',
        nextApply: 'Применить',
        nextReset: 'Сбросить',
        nextRecords: 'записей',
        nextPages: 'Страницы',
        nextGoToPage: 'Перейти на страницу {{page}}',
        nextPrevious: 'Назад',
        nextNext: 'Далее',
        nextPrevCard: 'Предыдущая карточка',
        nextNextCard: 'Следующая карточка',
        nextEmpty: 'Нет записей с такими фильтрами.',
        nextId: 'ID',
        nextType: 'Тип',
        nextDescription: 'Описание',
        nextImage: 'Изображение',
        nextSourceFile: 'Исходный файл',
        nextScene: 'Сцена',
        nextConcepts: 'Концепции',
        nextIntroduces: 'Добавляет',
        nextReinforces: 'Закрепляет',
        nextRequires: 'Требует',
        nextConceptCountsHint: 'Число карточек с концепцией до текущей карточки включительно.',
        nextConceptOccurrences: '{{concept}}: число карточек — {{count}}, включая текущую',
        nextCardPreview: 'Предпросмотр карточки',
        nextCopyCardId: 'Копировать ID карточки',
        nextCopyPrompt: 'Копировать промпт',
        nextCopyPromptMj: 'Копировать промпт с параметрами MJ',
        nextImagesInheritedFrom: 'Изображения унаследованы от',
        nextAddLanguage: 'Добавить язык',
        nextLanguages: 'Языки',
        nextNoLanguages: 'Без языков',
        nextText: 'Текст',
        nextImageDescription: 'Описание изображения',
        nextTextDescription: 'Заметка о тексте',
        nextEntityPreview: 'Предпросмотр сущности',
        nextPrompt: 'Промпт генерации',
        nextDependencies: 'Зависимости генерации',
        nextFullscreenImage: 'Полноразмерное изображение',
        nextNoDependencies: 'Медиа-референсов нет.',
        nextDependentCards: 'Зависимые карточки',
        nextNoDependentCards: 'От этой сущности не зависят карточки.',
        nextDependentAsReference: 'референс',
        nextDependentAsMention: 'упоминание',
        nextLore: 'Лор',
        nextShowSchema: 'Показать схему',
        nextSchemaTitle: 'Схема связей сущности',
        nextSchemaDescription: 'Все связи сущности в виде Mermaid-схемы.',
        nextSchemaDepth: 'Глубина',
        nextSchemaTypes: 'Типы связей',
        nextSchemaGroups: 'Группы связей',
        nextRelationGroup_family: 'Родственные',
        nextRelationGroup_ownership: 'Владение',
        nextRelationGroup_social: 'Отношения',
        nextRelationGroup_other: 'Другое',
        nextOutgoingRelationships: 'Исходящие',
        nextIncomingRelationships: 'Входящие',
        nextSchemaEmpty: 'Нет связей под эти фильтры.',
        nextSchemaLoading: 'Загрузка схемы...',
        nextSchemaLoadFailed: 'Не удалось загрузить схему',
        nextAdditionalImages: 'Другие изображения',
        nextSelectEntity: 'Выберите сущность для просмотра.',
        nextNoText: 'Для этого языка текста нет.',
        nextMediaUnavailable: 'Изображение недоступно',
        nextSelectCard: 'Выберите карточку для просмотра.',
        nextItemsHint: 'Каждая запись связана с исходным YAML-файлом.',
        nextDropImageHint: 'Перетащите сюда картинку для замены. Размер станет 1024x768.',
        nextUploadingImage: 'Загрузка изображения...',
        nextImageDescriptionPending: 'Картинка обновлена. Описание скоро появится.',
        nextImageUploadFailed: 'Не удалось загрузить изображение',
      },
      auth: {email: 'Email', password: 'Пароль', signInPassword: 'Войти', or: 'или'},
      materials: {},
    },
  },
}
